import { Box, ColorOptions, Icon, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import React, { useState } from 'react'
import { FlatList } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import { isMobileWidth } from '../../util/util'

interface Props {
  data: any
}

const RenderBox = ({ item }: any) => {
  const [dimens, setDimens] = useState({ h: 0, w: 0 })
  const Component = item.component
  const { textSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  return (
    <>
      <Box
        borderRadius={16}
        padding={isMobile ? 24 : 40}
        width={isMobile ? undefined : 274}
        marginBottom={40}
        marginRight={isMobile ? 8 : 10}
        zIndex={100}
        borderWidth={1}
        bg={'WHITE'}>
        <Box
          onLayout={(evt: any) =>
            setDimens({ h: evt?.nativeEvent?.layout?.height ?? 0, w: evt?.nativeEvent?.layout?.width ?? 0 })
          }>
          {!!Component && <Component height={isMobile ? 32 : 40} width={isMobile ? 32 : 40} />}
          {!!item.icon && (
            <Icon id={item.icon} size={isMobile ? 32 : 40} color={colors.JIO_PRIMARY_ALPHA as ColorOptions} />
          )}
          {!!item.imgUrl && (
            <Image source={item.imgUrl} height={isMobile ? 32 : 40} width={isMobile ? 32 : 40} resizeMode="contain" />
          )}
          <Spacer size={isMobile ? 16 : 24} />
          <Text
            title={item.title}
            fontFamily={'jiotype-black'}
            fontSize={textSize}
            lineHeight={isMobile ? 20 : 28}
            color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
          />
        </Box>
      </Box>
      {dimens?.h > 0 && (
        <LinearGradientContainer
          colorArray={item.bg}
          direction="HORIZONTAL"
          useAngle={true}
          angle={126}
          customStyle={{
            width: isMobile ? dimens?.w + 48 : 274,
            height: isMobile ? dimens?.h + 48 : dimens?.h + 80,
            borderRadius: 16,
            borderWidth: 1,
            position: 'absolute',
            top: 10,
            left: 10,
            borderColor: 'black',
            zIndex: -100,
          }}>
          <></>
        </LinearGradientContainer>
      )}
    </>
  )
}

export const BoxLayout = React.memo(({ data }: Props) => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  return (
    <Box flexDirection={'row'}>
      <Box f={isMobile ? 1 : undefined}>
        <FlatList data={data.leftColumn} renderItem={({ item }) => <RenderBox item={item} />} />
      </Box>
      <Spacer size={isMobile ? 16 : 30} direction={'horizontal'} />
      <Box marginTop={40} f={isMobile ? 1 : undefined}>
        <FlatList data={data.rightColumn} renderItem={({ item }) => <RenderBox item={item} />} />
      </Box>
    </Box>
  )
})
